module.exports = __webpack_public_path__ + "assets/img/masking_bg.171a3839.png";